module.exports = __webpack_public_path__ + "static/10-ca4db7f98862ea665160e1337847e387.jpg";